import React, { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { SearchResultDecisions } from './decision/SearchResultDecisions';
import { SearchResultCommentaries } from './commentary/SearchResultCommentaries';
import { SearchResultLegislations } from './legislation/SearchResultLegislations';
import { SearchResultLawyerOrLawfirm } from './lawyer-lawfirm/SearchResultLawyerOrLawfirm';
import { SearchResultEnterprise } from './enterprise/SearchResultEnterprise';
import { FeedbackBox } from './feedback-box/FeedbackBox';

import { LawfirmHit, LawyerHit, SearchAPIResponse } from '../../search.types';
import { QueryParamsType } from '../../state/reducers/queryParams.types';
import { ResultsType } from '../../state/reducers/results.types';
import { UserContextType } from '../../../user/user.types';

type Props = {
  loggedIn: UserContextType['loggedIn'];
  hits: SearchAPIResponse['hits'];
  ended: SearchAPIResponse['theEnd'];
  type: QueryParamsType['type'];
  isSearchLoading: ResultsType['searchLoading'];
  isPaginationLoading: ResultsType['paginationLoading'];
  needMoreHits: Function;
  parentContainerRef?: HTMLDivElement | null;
};

export const SearchResults: FC<Props> = ({
  hits,
  ended,
  type,
  loggedIn,
  isSearchLoading,
  isPaginationLoading,
  needMoreHits,
  parentContainerRef,
}) => {
  const numberOfHits = hits.length;

  const loadData = async () => {
    if (!isSearchLoading && !isPaginationLoading) {
      needMoreHits();
    }
  };

  return (
    <>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadData}
        hasMore={loggedIn && !ended}
        initialLoad={false}
        useWindow={!parentContainerRef}
        getScrollParent={
          parentContainerRef ? () => parentContainerRef : () => null
        }
      >
        <>
          {type === 'arret' && (
            // @ts-ignore
            <SearchResultDecisions decisions={hits} />
          )}
          {type === 'commentary' && (
            // @ts-ignore
            <SearchResultCommentaries commentaries={hits} />
          )}

          {type === 'law' && (
            // @ts-ignore
            <SearchResultLegislations legislations={hits} />
          )}
          {type === 'lawyer' && (
            <SearchResultLawyerOrLawfirm
              hits={hits as (LawfirmHit | LawyerHit)[]}
            />
          )}
          {type === 'enterprise' && (
            <SearchResultEnterprise enterprises={hits} />
          )}
          {ended && numberOfHits > 1 && numberOfHits < 10 && <FeedbackBox />}
        </>
      </InfiniteScroll>
    </>
  );
};
